import {
  IN_PROGRESS,
  SCRAPING_SESSION_VALIDATION_IN_PROGRESS,
  VALIDATABLE_SCRAPING_SESSION_STATUSES,
} from '../constants'

export const canValidateScrapingSession = (
  scrapingSession,
  validatingScrapingSessionIds = [],
) =>
  ((scrapingSession.status === IN_PROGRESS &&
    scrapingSession.validatableMenuCount > 0) ||
    (VALIDATABLE_SCRAPING_SESSION_STATUSES.includes(scrapingSession.status) &&
      Number(scrapingSession.scrapingTestCaseResultCount) ===
        Number(scrapingSession.scrapingTestCaseCount))) &&
  !validatingScrapingSessionIds.includes(scrapingSession.id) &&
  scrapingSession.validationStatus !== SCRAPING_SESSION_VALIDATION_IN_PROGRESS

export const getValidationConfirmationContent = scrapingSession =>
  scrapingSession.status === IN_PROGRESS
    ? `Only ${scrapingSession.validatableMenuCount} of ${scrapingSession.scrapingTestCaseCount} menus can currently be validated. The result will be partial until scraping completes.`
    : 'This will calculate validation metrics for this session.'
